import { forwardRef } from 'react';
import { cn } from '@/lib/utils';

export interface CheckboxProps extends React.InputHTMLAttributes<HTMLInputElement> {
  label?: React.ReactNode;
  error?: string | undefined;
}

const Checkbox = forwardRef<HTMLInputElement, CheckboxProps>(
  ({ className, label, error, id, ...props }, ref) => (
    <div className="flex flex-col gap-1">
      <div className="flex items-start gap-2">
        <input
          ref={ref}
          type="checkbox"
          id={id}
          className={cn(
            'mt-0.5 h-4 w-4 rounded-sm border border-linen text-copper',
            'focus:ring-2 focus:ring-copper focus:ring-offset-1',
            'cursor-pointer accent-copper',
            error && 'border-rust',
            className
          )}
          {...props}
        />
        {label && (
          <label htmlFor={id} className="text-sm text-iron leading-snug cursor-pointer">
            {label}
          </label>
        )}
      </div>
      {error && <p className="text-xs text-rust ml-6">{error}</p>}
    </div>
  )
);
Checkbox.displayName = 'Checkbox';

export { Checkbox };
